<template>
  <div>
    <el-form
      ref="searchForm"
      :inline="true"
      class="searchBoxLine"
      :model="searchForm"
    >
      <el-form-item label="单据编号:" prop="orderNum">
        <el-input v-model="searchForm.orderNum" placeholder="输入内容" />
      </el-form-item>
      <el-form-item label="客户名称:" prop="customerName">
        <el-input v-model="searchForm.customerName" placeholder="输入内容" />
      </el-form-item>
      <el-form-item label="申请时间:" prop="startDate">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.startDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block; width: 10px; text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="统一社会信用代码:">
        <el-input v-model="searchForm.creditCode" placeholder="输入内容" />
      </el-form-item>
      <el-form-item>
        <div style="display: flex; justify-content: flex-end;">
          <el-button type="primary" :loading="loading" @click="doSearchList">
            搜索
          </el-button>
          <el-button type="default" @click="resetForm">
            重置
          </el-button>
        </div>
      </el-form-item>
    </el-form>
    <div style="margin: 0 0 10px 0;">
      <el-button type="primary" @click="goApplication">
        新建授信申请
      </el-button>
    </div>
    <div class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="contractNum" label="操作" width="150px" align="left">
          <template v-slot="{ row }">
            <el-button
              v-if="row.editFlag"
              type="text"
              class="box-btn"
              @click="editClick(row)"
            >
              编辑
            </el-button>
            <el-button
              v-else
              type="text"
              class="box-btn"
            >
              -
            </el-button>
            <el-button
              v-if="row.abandoneFlag"
              type="text"
              class="box-btn"
              @click="abandonClick(row)"
            >
              废弃
            </el-button>
            <el-button
              v-else
              type="text"
              class="box-btn"
            >
              -
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="orderNum" label="单据编号" width="150px" align="left">
          <template v-slot="{ row }">
            <el-button type="text" @click="checkDetail(row)">
              {{ row.orderNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" label="客户名称" width="200px" align="left" />
        <el-table-column prop="applicantType" label="申请类型" width="100px" align="left">
          <template v-slot="{ row }">
            <span v-if="row.applicantType === 0">固定额度</span>
            <span v-else-if="row.applicantType === 1">临时额度</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="applicantLimit"
          label="申请额度(万元)"
          align="right"
          width="100px"
        >
          <template v-slot="{ row }">
            {{ row.applicantLimit || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="applicantPeriod"
          label="申请账期"
          align="right"
          width="150px"
        >
          <template v-slot="{ row }">
            {{ row.applicantPeriod || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="approvalLimit"
          label="审批额度(元)"
          align="right"
          width="100px"
        >
          <template v-slot="{ row }">
            {{ row.approvalLimit || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="approvalPeriod"
          label="审批账期"
          align="right"
          width="150px"
        >
          <template v-slot="{ row }">
            {{ row.approvalPeriod || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="applicant" label="申请人" width="100px" align="left" />
        <el-table-column prop="applicantTime" label="申请时间" width="150px" align="left" />
        <el-table-column prop="processStatusName" label="当前状态" min-width="200px" align="left">
          <template v-slot="{ row }">
            {{ row.processStatusName || '-' }}
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <!-- 召回 -->
    <recall-dialog ref="recallDialog" @on-ok="sureRecallClick" />
    <!-- 流程 -->
    <ProcessDialog ref="processDialogRef" />
  </div>
</template>
<script type="es6">
import { getCreditControlList, abandonedCreditControl } from '@/API/creditAxios.js';
import RecallDialog from './recallDialog.vue';
import ProcessDialog from './processDialog.vue';

export default {
  data () {
    return {
      searchForm: {
        orderNum: '',
        customerName: '',
        startDate: '',
        endDate: '',
        creditCode: ''
      },
      loading: false,
      tableData: [],
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }

    };
  },
  components: {
    RecallDialog,
    ProcessDialog
  },
  computed: {},
  methods: {
    doSearch () {
      this.loading = true;
      getCreditControlList({
        ...this.searchForm,
        menuType: 3,
        current: this.page.currentPage,
        size: this.page.pageSize
      }).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.records;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    doSearchList () {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.orderNum = '';
      this.searchForm.customerName = '';
      this.searchForm.startDate = '';
      this.searchForm.endDate = '';
      this.searchForm.creditCode = '';
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.doSearch();
    },
    // 去申请
    goApplication () {
      this.$router.push({
        name: 'creditControlApplication',
        query: {
          type: 'create'
        }
      });
    },
    // 召回
    recall (row) {
      this.$refs.recallDialog.openDialog(row.id);
    },
    // 确认召回
    sureRecallClick () {
      this.doSearch();
    },
    // 编辑
    editClick (row) {
      this.$router.push({
        name: 'creditControlApplication',
        query: {
          type: 'edit',
          orderId: row.id
        }
      });
    },
    // 废弃
    abandonClick (row) {
      this.$confirm('您确定要废弃吗？', '', {
        confirmButtonText: '废弃',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          abandonedCreditControl(row.id).then((res) => {
            let { status } = res.data;
            if (status === '200') {
              this.$message.success('废弃成功');
              this.doSearch();
            }
          });
        })
        .catch(() => {});
    },
    checkDetail (params) {
      this.$router.push({
        name: 'creditControlApplicationDetail',
        query: {
          orderId: params.id
        }
      });
    },
    // 打开流程节点
    openProcessDialog (row) {
      this.$refs.processDialogRef.openDialog(row);
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>
<style scoped lang="scss">
.box-btn{
  width: 30px;
  padding-left: 0 !important;
}
:deep(.has-gutter .cell){
  text-align: left !important;
}
:deep(.el-form-item){
  width: 380px !important;
}
:deep(.el-form) {
  display: flex;
  flex-wrap: wrap;
}
:deep(.el-form-item:nth-last-child(1)){
  flex-grow: 1;
}
:deep(.el-form-item:nth-last-child(1) .el-form-item__content){
  width: 100% !important;
  justify-content: flex-end;
}
:deep(.el-form .el-input__inner){
  width: 273px;
}
:deep(.el-form .el-form-item:nth-last-child(3) .el-input__inner){
  width: 125px;
}
</style>
